import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import PrivateRoutes from './utils/PrivateRoutes';
import NotFound from './utils/NotFound';
import Home from './pages/Home';
import FAQ from './pages/FAQ';
import ContactUs from './pages/ContactUs';
import Terms from './pages/Terms';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Signature from './pages/Signature-test';
import About from './pages/About';
import Contact from './pages/Contact';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react'
import CreateAccount from './pages/createAccount/CreateAccount';
import PersonalInfo from './pages/createAccount/PersonalInfo';
import CreatePayment from './components/CreditCardForm';
import Contract from './pages/createAccount/Contract';
import Layout from './components/layout/Layout';
import QuickBooksPayment from './pages/payments/QuickBooksPayment'
import ScrollToTopButton from "./components/ScrollToTopButton";
import { LanguageProvider } from './components/LanguageContext';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <>
      <LanguageProvider>
        <ColorModeScript initialColorMode="light" />
        <ChakraProvider>
          <Layout menuOpen={menuOpen} setMenuOpen={setMenuOpen}>
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              {/* <Route path="/signUp" element={<SignUp />} /> */}
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contactUs" element={<ContactUs />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/signature" element={<Signature />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup/create-account" element={<CreateAccount />} />
              <Route path="/payment" element={<QuickBooksPayment />} />

              {/* <Route path="/singup/member-contract" element={<} */}
              <Route element={<PrivateRoutes />}>
                <Route path="/signup/personal-info/" element={<PersonalInfo />} />
                <Route path="/signup/contract/" element={<Contract />} />
                <Route path="/signup/create-payment/" element={<CreatePayment />} />
                <Route element={<Dashboard />} path="/dashboard" />
              </Route>

              <Route path="*" element={<NotFound />} />
            </Routes>
            <ScrollToTopButton menuOpen={menuOpen} />
          </Layout>
        </ChakraProvider>
      </LanguageProvider>
    </>
  );
};
export default App;